const DEV_PROXY_PREFIX = '/__proxy';

const withoutTrailingSlash = (url: string): string => url.replace(/\/$/, '');

/**
 * Routes a backend url through the dev server proxy when `target` names that backend,
 * e.g. `https://kunde.cmicloud.ch/api` -> `/__proxy/api`. The request is then same
 * origin and no longer needs CORS headers.
 *
 * Urls pointing at another host, and requests without a configured proxy, are left
 * untouched. The target comes from `devProxy` in `config.json`; see the "Dev proxy"
 * section in the README.
 */
export function toDevProxyUrl(url: string, target: string | undefined): string {
  if (!target) {
    return url;
  }

  const backend = withoutTrailingSlash(target);

  return url.startsWith(backend) ? `${DEV_PROXY_PREFIX}${url.slice(backend.length)}` : url;
}
